import React from 'react'
import { PLATFORM_VALUE } from '../platformConfig'
import JinXuan from './jinxuan'
import { getUserInfo } from '../../common/userInfo'
import CommonInspiration from './commonInspiration'

export default ({ batchSelected, ...otherProps }) => {
  const currentViewBlog = { ...otherProps.currentViewBlog, ...otherProps.currentViewBlog?.lastBlogList?.[0] }
  const platformId = Number(currentViewBlog?.platformId)
  const userInfo = getUserInfo()
  const visibleWhalePick = userInfo?.isWhalePick && platformId === PLATFORM_VALUE.ITEM
  && (!batchSelected || batchSelected?.length <= 1)

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {visibleWhalePick ? <JinXuan // 原采集代码 和 鲸选代码 拆离修改
      batchSelected={batchSelected}
      {...otherProps}
    /> : <CommonInspiration
      batchSelected={batchSelected}
      {...otherProps}
    />}
  </>
}
